import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { appRoutes } from '../utils/app_routes'

const BreadCrumb = () => {
    const { pathname } = useLocation()
    const route = pathname.replace(/[-/]/g, ' ')
    return (
        <>
            {
                pathname !== appRoutes.home ?
                    <div className='p-8  bg-black flex justify-center items-center text-white'>
                        <div>
                            <p className='capitalize text-[clamp(1.5rem,4vw,2.5rem)] font-[600] leading-[clamp(2rem,4vw,3.14rem)] text-primary'>
                                {route}
                            </p>
                            <p className='mt-4 text-[clamp(0.9rem,4vw,1.15rem)] font-[400]  capitalize'><Link to={appRoutes.home}>Home</Link> / {route}</p>
                        </div>
                    </div> : <></>
            }</>
    )
}

export default BreadCrumb